'use strict';
//objectFeedback
export default class ObjectFeedbackComponent {
	public restrict: any;
	public template: any;
	public scope: any;
	public controller: any;
	public controllerAs: any;
	public bindToController: any;

  constructor() {
    this.restrict = 'A'
    this.template = require('./object.feedback.component.html');
    this.scope = {
      alarmObject: '=',
      isEditable: '='
    };
    this.controller = ObjectFeedbackComponentController;
    this.controllerAs = 'ctrl';
    this.bindToController = true;
  }
}

/* @ngInject */
class ObjectFeedbackComponentController {
	public states: any;

  constructor() {
    this.states = ['PENDING', 'CREATED', 'ACCEPTED', 'DECLINED', 'RESOLVED'];
  }
}